import React, { Component } from "react"
import {
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Alert
} from 'reactstrap';
import MyExportCSV from '../../components/exportCSV';
import SweetAlert from 'react-bootstrap-sweetalert';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import InputMask from 'react-input-mask';
import { Search } from 'react-bootstrap-table2-toolkit';
// Components
import BtnLoader from '../../components/Loaders/btnLoader';
import moment from 'moment';
import { isNull } from "lodash";
import { onAddPriorityOrder, onUpdatePriorityOrder, onDeletePriorityOrder } from "../../app-socket/events/priority";
import { onAddTransfer, onUpdateAgent } from "../../app-socket/events/transfer";
import { Notification } from '../../components/Notifications/notifications';

const findDifference = (object1, object2) => {
  const differences = [];
  Object.keys(object1).forEach((key) => {
    const val1 = key === 'manager' ? object1[key].split('|')[0] : object1[key];
    const val2 = object2[key];
    if (typeof val1 !== "object" || typeof val2 !== "object") {
      if (val1 !== val2) {
        differences.push({
          key,
          value1: key === 'manager' ? object1[key].split('|')[0] : object1[key],
          value2: object2[key],
        });
      }
    } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
      differences.push({
        key,
        value1: object1[key],
        value2: object2[key],
      });
    }
  });
  return differences;
};
class FilterPrComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      priority_order: [],
      filtered_orders: [],
      my_priority_orders: [],
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toLocaleDateString('en-GB'),
      endDate: new Date().toLocaleDateString('en-GB'),
      paymentDate: '',
      packingDate: '',
      sendDate: '',
      checkDateChange: '',
      sl_manager_filter: '',
      correctDatePm: true,
      correctDatePack: true,
      correctDateSend: true,
      modalNewOrder: false,
      modalLockOrder: false,
      transferAgentFields: false,
      buttonTgl: false,
      isEdit: false,
      selectedManager: this.props.props.profileData._id,
      seoulTime2pm: moment.tz('14:00', 'HH:mm', 'Asia/Seoul'),
      error: null,
      warning: null,
      alertSc: null
    }
    this.filterMyOrders = this.filterMyOrders.bind(this);
    this.showServices = this.showServices.bind(this);    
    this.loadArchive = this.loadArchive.bind(this);
    this.resetArchive = this.resetArchive.bind(this);
    this.toggleBtn = this.toggleBtn.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.resetFilterData = this.resetFilterData.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.handleHideCompletedOrders = this.handleHideCompletedOrders.bind(this);

    this.handleCopyOrderClick = this.handleCopyOrderClick.bind(this);
    this.handleEditOrderClick = this.handleEditOrderClick.bind(this);
    this.handleNewOrderClick = this.handleNewOrderClick.bind(this);
    this.toggleLockOrderModal = this.toggleLockOrderModal.bind(this);
    this.toggleNewOrderModal = this.toggleNewOrderModal.bind(this);
    this.toggleTransferAgent = this.toggleTransferAgent.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.handleValidOrderSubmit = this.handleValidOrderSubmit.bind(this);
    this.handleLockOrderSubmit = this.handleLockOrderSubmit.bind(this);
    this.checkPriorityAvailability = this.checkPriorityAvailability.bind(this);
    this.updateWarningState = this.updateWarningState.bind(this);
    this.myRef = React.createRef();

    // functions to handle order deletion
    this.handleDeletePriorityOrder = this.handleDeletePriorityOrder.bind(this);
    this.deleteOrderAlert = this.deleteOrderAlert.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.checkDateChange !== this.state.checkDateChange || prevState.selectedManager !== this.state.selectedManager) {
      this.updateWarningState()
    }
  }
  /**
   * Function to display orders only related to login person
   * @param {*} e
   */
  filterMyOrders = (e) => {
    const { priority_orders, profileData } = this.props.props;
    let my_priority_orders = [];
    if (e.target.checked === true) {
      priority_orders.map((order) => {
        if (order.manager._id === profileData._id) {
          my_priority_orders.push(order);
        }
      });
      if (my_priority_orders.length === 0) {
        my_priority_orders.push({ manager: 'No Results Found' });
      }
      this.setState({ my_priority_orders: my_priority_orders });
    } else {
      this.setState({ my_priority_orders: [] });
    }
    this.props.onStateChange('filter', my_priority_orders);
  };
  /**
   * Display services rules on click
   */
  showServices = () => {
    const getAlert = () => (
      <SweetAlert
        title={
          <>
            <h1 className='fw-bold'>Fedex/DHL</h1>
            <hr className='hor_popup' id='fedex' />
            <p className='font-size-18'>Collect ~16:00</p>
            <p className='font-size-18'>Official docs (CIPL) before 13:00</p>
            <p className='font-size-18'>Other docs (CI, prod desc) before 15 00</p>

            {/* <h1 className='fw-bold '>DHL</h1>
            <hr className='hor_popup' id='dhl' />
            <p className='font-size-18'>Collect ~16:00</p> */}

            {/* <h1 className='fw-bold'>Docs </h1> */}
            {/* <hr className='hor_popup' id='kor_post' /> */}

            <h1 className='fw-bold'>EMS</h1>
            <hr className='hor_popup' id='ems' />
            <p className='font-size-18'>Collect ~15:00</p>
            <p className='font-size-18'>Official docs (CIPL) before 13:00</p>
            <p className='font-size-18'>Other docs-CI, declaration (ems premium) before 14 00</p>

            <br />
            {/* <p className='font-size-18'>Export Permit and COO request before 1pm.</p> */}

            <h1 className='fw-bold'>Korean Post</h1>
            <hr className='hor_popup' id='q_serv' />
            <p className='font-size-18'>~next day before 12</p>

            <h3 className='fw-bold'>Quick Service</h3>
            <hr className='hor_popup' id='q_serv' />
            <p className='font-size-18'>On request</p>
          </>
        }
        onConfirm={() => this.setState({ alertSc: false })}
      ></SweetAlert>
    );
    this.setState({ alertSc: getAlert() });
  };
  /**
   * Load archived orders
   */
  loadArchive = () => {
    const data = 50;
    this.props.onStateChange('loadArchive', data);
    this.toggleBtn()
  };
  /**
   * Change button
   */
  toggleBtn = () => this.setState((prevState) => ({ buttonTgl: !prevState.buttonTgl }));
  /**
   * Function to change selected value of state
   * @param {*} e
   * @returns state for selected value
   */
  handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });
  /**
   * Function to handle date input
   * @param {*} event
   */
  onChangeValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    // if (parseFloat(event.target.value.substring(3, 5)) > 12) {
    //   this.setState({ correctDate: false });
    // } else {
    //   this.setState({
    //     correctDate: true,
    //     [event.target.name]: event.target.value
    //   });
    // }
  };
  /**
   * Function to filter data from selected year/month/manager
   * @param {*} e
   * @param {array} values
   * @returns filtered data
   */
  handleFilterDataSubmit = (e, values) => {
    const { startDate, endDate } = this.state;
    const { onGetSpecificPriorityOrders } = this.props.props;
    const data = {
      startDate: values.date_type === 'pd' ? startDate.split('/').reverse().join('-') : startDate,
      endDate: values.date_type === 'pd' ? endDate.split('/').reverse().join('-') : endDate,
      manager: values.manager,
      date: values.date_type
    }
    onGetSpecificPriorityOrders(data)
  };
  /**
   * Function to reset selected filer and load current data
   */
  resetFilterData = () => {
    // const createOrderBtn = document.getElementById('create-order-btn');
    // const myOrders = document.getElementById('myOrders');
  
    // if (createOrderBtn) createOrderBtn.disabled = false;
    // if (myOrders) myOrders.disabled = false;
    this.setState({ filtered_orders: [], startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toLocaleDateString('en-GB'), endDate: new Date().toLocaleDateString('en-GB'), manager: '', formKey: Math.random() });
    this.props.onStateChange('reset_filter', this.state.filtered_orders);
  };
  /**
   * reload window to reset archive orders
   * @returns 
   */
  resetArchive = () => window.location.reload();
  /**
   * Function to hide completed orders
   */
  handleHideCompletedOrders = () => {
    const { priority_orders, dispatch, /* onUpdatePriorityOrder */ } = this.props.props;
    let hiddenArr = [];
    priority_orders.map((row) => {
      if (row['completedOrder'] === true) {
        row['hidden'] = true;
        row['importantOrder'] = false;
        hiddenArr.push({
          _id: row['_id'],
          invoiceNo: row['invoiceNo'],
          hidden: row['hidden'],
          importantOrder: row['importantOrder']
        });
      }
    });
    onUpdatePriorityOrder({ dispatch, data: hiddenArr });
  };
  /**
   * Empty priority orders array and set edit to false. Open new order modal
   */
  handleNewOrderClick = () => {
    this.setState({ priority_order: '', isEdit: false, error: null, warning: null, paymentDate: '', packingDate: '', sendDate: '', selectedManager: this.props.props.profileData._id });
    this.toggleNewOrderModal();
  };
  /**
   * Set new order modal to open or close
   */
  toggleNewOrderModal = () => {
    this.setState(
      (prevState) => ({ modalNewOrder: !prevState.modalNewOrder, transferAgentFields: false }),
      () => {
        setTimeout(() => {
          this.autoFocusInput.getInputDOMNode().focus();
        }, 1);
      }
    );
  };
  toggleLockOrderModal = () => this.setState((prevState) => ({ modalLockOrder: !prevState.modalLockOrder }));
  /**
   * Show/hide transfer agent fields
   */
  toggleTransferAgent = () => this.setState((prevState) => ({ transferAgentFields: !prevState.transferAgentFields }));
  /**
   * Function to handle date input
   * @param {*} event
   */
  onChangeDate = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      if(event.target.name === 'paymentDate') this.setState({ correctDatePm: false });
      if(event.target.name === 'packingDate') this.setState({ correctDatePack: false });
      if(event.target.name === 'sendDate') this.setState({ correctDateSend: false });
    } else {
      if(event.target.name === 'paymentDate') this.setState({ correctDatePm: true, [event.target.name]: event.target.value });
      if(event.target.name === 'packingDate') this.setState({ correctDatePack: true, [event.target.name]: event.target.value, sendDate: event.target.value,  checkDateChange: event.target.value });
      if(event.target.name === 'sendDate') this.setState({ correctDateSend: true, [event.target.name]: event.target.value });
      
    }
  };
  /**
   * Function to handle manager selection
   * @param {*} event
   */
  onChangeSelectManager = (event) => this.setState({ selectedManager: event.target.value })
  /**
   * Function to assign values of selected order to priority_order array for copying
   * @param {array} priority_order
   */
  handleCopyOrderClick = (priority_order) => {
    this.setState({
      priority_order: {
        _id: priority_order._id,
        invoiceNo: priority_order.invoiceNo,
        client_info: priority_order.client_info ? priority_order.client_info : '',
        manager: priority_order.manager._id,
        delService: priority_order.delService,
        qr: priority_order.qr,
        toWH: priority_order.toWH,
        threads: priority_order.threads,
        managerCom: priority_order.managerCom,
        docsReady: priority_order.docsReady,
        official: priority_order.official,
        importantOrder: priority_order.importantOrder,
        paymentDate: priority_order.paymentDate,
        packingDate: priority_order.packingDate,
        sendDate: priority_order.sendDate,
        shouldSendNotification: priority_order.shouldSendNotification,
        transferAgentSent: priority_order.transferAgentSent,
      },
      isEdit: false,
      paymentDate: new Date(priority_order.paymentDate).toLocaleDateString('en-GB'),
      packingDate: priority_order.packingDate,
      sendDate: priority_order.sendDate,
      error: null,
      warning: null,
      selectedManager: priority_order.manager._id
    });
    this.toggleNewOrderModal();
  };
  /**
   * Function to assign values of selected order to priority orders array for editing
   * @param {array} priority_order
   */
  handleEditOrderClick = (e, type, priority_order) => {
    const { /* onUpdatePriorityOrder,*/ dispatch, wh_managers, profileData } = this.props.props;
    this.setState({
      priority_order: {
        _id: priority_order._id,
        invoiceNo: priority_order.invoiceNo,
        client_info: priority_order.client_info ? priority_order.client_info : '',
        manager: priority_order.manager._id+'|'+priority_order.manager.bitrixID,
        delService: priority_order.delService,
        qr: priority_order.qr,
        toWH: priority_order.toWH,
        threads: priority_order.threads,
        managerCom: priority_order.managerCom,
        docsReady: priority_order.docsReady,
        official: priority_order.official,
        importantOrder: priority_order.importantOrder,
        paymentDate: priority_order.paymentDate !== null ? priority_order.paymentDate.substring(0, priority_order.paymentDate.indexOf('T')) : "",
        packingDate: priority_order.packingDate,
        sendDate: priority_order.sendDate,
        shouldSendNotification: priority_order.shouldSendNotification,
        transferAgentSent: priority_order.transferAgentSent,
        notificationSent: priority_order.notificationSent
      },
      paymentDate: new Date(priority_order.paymentDate).toLocaleDateString('en-GB'),
      packingDate: priority_order.packingDate,
      sendDate: priority_order.sendDate,
      // date1: new Date(priority_order.packingDate.split('/').reverse().join('-')).setHours(0, 0, 0, 0),
      isEdit: true,
      error: null, 
      warning: null,
      selectedManager: priority_order.manager._id
    });
    if (type === 'not checkbox') { this.toggleNewOrderModal(); }
    else if (type === 'transfer agent') { this.toggleTransferAgentModal(); }
    else if (type === 'manager') {
      const previousMan = priority_order['whManager'];
      let currentMan = '';
      const updatedPriorityOrder = {
        _id: priority_order._id,
        whManager: e.target.value === 'select' ? null : e.target.value,
        historyData: '',
      };
      wh_managers.map((manager, index) => {
        if (manager._id === e.target.value) {
          currentMan = manager.fname + ' ' + manager.sname;
        }
      });
      const historyData = {
        order_id: priority_order['_id'],
        manager: profileData.fname + ' ' + profileData.sname,
        action: `<b>WH Manager</b> from <b>${isNull(previousMan) ? 'empty' : previousMan.fname +' '+previousMan.sname}</b> to <b>${currentMan}</b><br>`,
        updated: new Date().toLocaleString('en-GB')
      };
      updatedPriorityOrder['historyData'] = historyData
      onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });
    }
    else if (type === 'checkbox') {
      const updatedPriorityOrder = {
        _id: priority_order._id,
        [e.target.name]: e.target.checked,
        bitrixID: priority_order.manager.bitrixID,
        notificationSent: e.target.name === 'pckCompleted' ? !priority_order.notificationSent : priority_order.notificationSent,
        shouldSendNotification: priority_order.shouldSendNotification,
        transferAgentSent: priority_order.transferAgentSent,
        // completedOrder: (e.target.name === 'bookedPickup' && !priority_order.readyToShip) ? false : priority_order.completedOrder,
        invoiceNo: priority_order.invoiceNo,
        wh_manager: priority_order.whManager ? priority_order.whManager.fname +' '+ priority_order.whManager.sname : '',
        client_name: priority_order.client_info.clientName,
        delService: priority_order.delService,
        historyData: '',
        module: 'Bot Priority Notification',
        // option: e.target.name === 'pckCompleted' && !priority_order.notificationSent && priority_order.shouldSendNotification && !['EMS', 'DHL', 'Fedex'].includes(priority_order.delService)
        //         ? 'pckCompletedProrderSpecialDel'
        //         : e.target.name === 'pckCompleted' && !priority_order.notificationSent && priority_order.shouldSendNotification
        //         ? 'pckCompletedProrder'
        //         : ''
        option: [
          e.target.name === 'pckCompleted' &&  !priority_order.notificationSent &&  priority_order.shouldSendNotification && !['EMS', 'DHL', 'Fedex'].includes(priority_order.delService) && 'pckCompletedProrderSpecialDel',
          e.target.name === 'pckCompleted' && !priority_order.notificationSent &&  priority_order.shouldSendNotification &&'pckCompletedProrder'
        ].filter(Boolean)
      };
      const historyData = {
        order_id: priority_order['_id'],
        manager: profileData.fname + ' ' + profileData.sname,
        action: `<b>${e.target.name}</b> to ${e.target.checked ? '<b>checked</b>' : '<b>not checked</b>'}<br>`,
        updated: new Date().toLocaleString('en-GB')
      };
      updatedPriorityOrder['historyData'] = historyData
      onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });
    }
    else if (type === 'toxThrPackaged') {
      const toxThrPackagedStatus = {
        _id: priority_order._id,
        toxThrPackaged: priority_order.toxThrPackaged === true ? false : true,
        historyData: '',
      };
      const historyData = {
        order_id: priority_order._id,
        manager: profileData.fname + ' ' + profileData.sname,
        action: `<b>Threads</b> from <b>${priority_order.toxThrPackaged ? 'Packed' : 'Not Packed'}</b> to <b>${!priority_order.toxThrPackaged ? 'Packed' : 'Not Packed'}</b><br>`,
        updated: new Date().toLocaleString('en-GB')
      };
      toxThrPackagedStatus['historyData'] = historyData
      onUpdatePriorityOrder({ dispatch, data: toxThrPackagedStatus });
    }
    else if (type === 'qrScanned') {
      const toxThrPackagedStatus = {
        _id: priority_order._id,
        qrScanned: priority_order.qrScanned === true ? false : true,
        historyData: '',
      };
      const historyData = {
        order_id: priority_order._id,
        manager: profileData.fname + ' ' + profileData.sname,
        action: `<b>QR</b> from <b>${priority_order.qrScanned ? 'Scanned' : 'Not Scanned'}</b> to <b>${!priority_order.qrScanned ? 'Scanned' : 'Not Scanned'}</b><br>`,
        updated: new Date().toLocaleString('en-GB')
      };
      toxThrPackagedStatus['historyData'] = historyData
      onUpdatePriorityOrder({ dispatch, data: toxThrPackagedStatus });
    }
    else if (type === 'pickup') {
      e.preventDefault();
      const fieldName = e.target.name;
      const currentChecked = !!priority_order[fieldName];
        // Prevent visual checkbox change immediately
      e.target.checked = currentChecked;
        // If already checked, uncheck without confirmation
      if (currentChecked) {
        this.updateBookedPickup(priority_order, false, fieldName);
        return;
      }
      // If unchecked, ask confirmation before checking
      const getAlert = () => (
        <SweetAlert
          warning
          showCancel
          confirmBtnText="Yes, order is ready!"
          confirmBtnBsStyle="success"
          title="Are you sure?"
          onConfirm={() => this.updateBookedPickup(priority_order, true, fieldName)}
          onCancel={this.props.hideAlert}
          focusCancelBtn
        >
          Are you sure the order with Invoice
          <span className="fw-bold"> #{priority_order.invoiceNo}</span> is ready?
        </SweetAlert>
      );
      this.props.onStateChange('alert', getAlert());
      return;
    }
    else if (type === 'completed') {
      const updatedPriorityOrder = {
        _id: priority_order._id,
        [e.target.name]: e.target.checked,
        client_name: priority_order.client_info.clientName,
        invoiceNo: priority_order.invoiceNo,
        wh_manager: priority_order.whManager?.fname +' '+ priority_order.whManager?.sname,
        bitrixID: priority_order.manager.bitrixID,
        completedOrder: e.target.checked ? true : false,
        historyData: '',
        module: 'Bot Priority Notification',
        option: e.target.name === 'readyToShip' && e.target.checked ? 'rdyShipProrder' : ''
      };
      const historyData = {
        order_id: priority_order['_id'],
        manager: profileData.fname + ' ' + profileData.sname,
        action: `<b>${e.target.name}</b> to ${e.target.checked ? '<b>checked</b>' : '<b>not checked</b>'}<br>`,
        updated: new Date().toLocaleString('en-GB')
      };
      updatedPriorityOrder['historyData'] = historyData
      onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });
    }
    if (type === 'locked') {
      if (priority_order.onHold === true) {
        const updatedPriorityOrder = {
          _id: priority_order._id,
          lockReason: '',
          lockedBy: null,
          onHold: priority_order.onHold === true ? false : true,
          historyData: ''
        };
        const historyData = {
          order_id: priority_order['_id'],
          manager: profileData.fname + ' ' + profileData.sname,
          action: `<b>On Hold</b> reason was removed<br>`,
          updated: new Date().toLocaleString('en-GB')
        };
        updatedPriorityOrder['historyData'] = historyData
        onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });
      } else {
        this.toggleLockOrderModal();
      }
    } 
  };
updateBookedPickup = (priority_order, checked, fieldName = 'bookedPickup') => {
  const { dispatch, profileData } = this.props.props;

  const updatedPriorityOrder = {
    _id: priority_order._id,
    [fieldName]: checked,

    client_name: priority_order.client_info ? priority_order.client_info.clientName : '',
    invoiceNo: priority_order.invoiceNo,

    wh_manager: priority_order.whManager
      ? priority_order.whManager.fname + ' ' + priority_order.whManager.sname
      : '',

    bitrixID: priority_order.manager.bitrixID,
    // completedOrder: checked ? true : false,
    historyData: ''
  };

  const historyData = {
    order_id: priority_order['_id'],
    manager: profileData.fname + ' ' + profileData.sname,
    action: `<b>${fieldName}</b> to ${checked ? '<b>checked</b>' : '<b>not checked</b>'}<br>`,
    updated: new Date().toLocaleString('en-GB')
  };

  updatedPriorityOrder['historyData'] = historyData;
  onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });

  this.props.hideAlert();
};
  /**
   * Function to submit new order or edit current order
   * @param {*} e
   * @param {array} values
   */
  handleValidOrderSubmit = (e, values) => {
    const {
      // onAddNewPriorityOrder,
      // onUpdatePriorityOrder,
      // onAddTransfer,
      // onUpdateAgent,
      tr_agents,
      sl_managers,
      profileData,
      dispatch,
    } = this.props.props;
    const { isEdit, priority_order, paymentDate, packingDate, sendDate } = this.state;
    if (isEdit) {
      const wasTransferAgentSent = Boolean(priority_order.transferAgentSent);
      const transferAgentSent = Boolean(values.transferAgentSent);
      const shouldSendToTransferAgent = !wasTransferAgentSent && transferAgentSent;

      const updatedPriorityOrder = {
        _id: priority_order._id,
        paymentDate: paymentDate.split('/').reverse().join('-'),
        invoiceNo: values.invoiceNo,
        client_info: { clientName: values.clientName, length: 0 },
        client_name: values.clientName,
        whManager: values.toWH ? values.manager.split('|')[0] : priority_order.whManager,
        manager: values.manager.split('|')[0],
        packingDate: packingDate,
        sendDate: sendDate,
        delService: values.delService,
        qr: values.qr,
        toWH: values.toWH,
        threads: values.threads,
        managerCom: values.managerCom,
        importantOrder: values.importantOrder !== 'undefined'
          ? values.importantOrder
          : priority_order.importantOrder,
        docsReady: values.docsReady,
        official: values.official,
        shouldSendNotification: values.shouldSendNotification,
        notificationSent: priority_order.notificationSent,
        transferAgentSent: wasTransferAgentSent || transferAgentSent,
        bitrixID: values.manager.split('|')[1],
        historyData: '',
        module: 'Bot Priority Notification',

        option: shouldSendToTransferAgent ? 'prorderToTransfer' : ''
      };
      // find differences and record changes
      const difference = findDifference(priority_order, updatedPriorityOrder);
      const historyData = {
        updated: new Date().toLocaleString('en-GB'),
        order_id: priority_order._id,
        manager: profileData.fname + ' ' + profileData.sname,
        action: ``
      };
      let manager1 = '';
      let manager2 = '';
      difference.map((dif) => {
        if(dif.key === "manager"){
          manager1 = sl_managers.find(manager => manager._id === dif.value1);
          manager2 = sl_managers.find(manager => manager._id === dif.value2);
          historyData['action'] += `<b>${dif.key}</b> from <b>${dif.value1 === '' ? 'empty' : manager1.fname +' '+manager1.sname}</b> to <b>${manager2.fname +' '+manager2.sname}</b> <br>`;
        }
        if(dif.key === "client_info"){
          historyData['action'] += `<b>${dif.key}</b> from <b>${dif.value1 === '' ? 'empty' : dif.value1.clientName}</b> to <b>${dif.value2.clientName}</b> <br>`;
        }
        else {
          historyData['action'] += `<b>${dif.key}</b> from <b>${dif.value1 === '' ? 'empty' : dif.value1}</b> to <b>${dif.value2}</b> <br>`;
        }
      });
      updatedPriorityOrder['historyData'] = historyData
      if (shouldSendToTransferAgent) {
        let lowestPayment = [];
        let lowestOrders = [];
        lowestPayment = [...new Map(tr_agents.map((v) => [v.mainName, v])).values()];
        lowestPayment.sort(function (a, b) { return a.paymentAmount - b.paymentAmount; });
        tr_agents.map((id) => {
          if (lowestPayment[0]['mainName'] === id.mainName && id.onVacation === false) {
            lowestOrders.push(id);
          }
        });
        lowestOrders.sort(function (a, b) { return a.orderAmount - b.orderAmount; });
        const newAgentFee = {
          _id: lowestOrders[0]['_id'],
          mainName: lowestOrders[0]['mainName'],
          paymentAmount: lowestOrders[0]['paymentAmount'] + 0,
          orderAmount: lowestOrders[0]['orderAmount'] + 1
        };
        const newTransfer = {
          invoiceNo: values['invoiceNo'],
          manager: values['manager'].split('|')[0],
          clientName: values['clientName'],
          address: values['address'],
          agentPaid: false,
          agent: lowestOrders[0]['_id'],
          agentPaymentAmount: 0,
          completed: false,
          workNeeded: false,
          problem: false,
          customFees: null,
          clientPayment: null,
          currentlyWorking: false,
          workDone: false,
        };
        const combinedData = [newTransfer, newAgentFee]
        onAddTransfer({ dispatch, combinedData });
        // onAddTransfer({ dispatch, newTransfer });
        // onUpdateAgent({ dispatch, newAgentFee });
      }
      onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder});
    } else {
      const newPriorityOrder = {
        managerCreated: profileData.fname + ' ' + profileData.sname,
        paymentDate: paymentDate.split('/').reverse().join('-'),
        invoiceNo: values['invoiceNo'],
        client_info: { clientName: values['clientName'] },
        client_name: values['clientName'],
        manager: values['manager'].split('|')[0],
        whManager: values['toWH'] ? values['manager'].split('|')[0] : null,
        packingDate: packingDate,
        sendDate: sendDate,
        delService: values['delService'],
        qr: values['qr'],
        threads: values['threads'],
        managerCom: values['managerCom'],
        importantOrder: values['importantOrder'],
        pckStarted: false,
        // pckCompleted: false,
        docsReady: values['docsReady'],
        official: values['official'],
        toWH: values['toWH'],
        bookedPickup: false,
        readyToShip: false,
        logisticCom: '',
        hidden: false,
        onHold: false,
        qrScanned: false,
        toxThrPackaged: false,
        shouldSendNotification: values['shouldSendNotification'],
        transferAgentSent: values['transferAgentSent'],
        bitrixID: values['manager'].split('|')[1],
        notificationSent: false,
        completedOrder: false,
        module: 'Bot Priority Notification',
        option: values['transferAgentSent'] ? 'prorderToTransfer' : '',        
      };
      if(values['transferAgentSent']) {
        let lowestPayment = [];
        let lowestOrders = [];
        lowestPayment = [...new Map(tr_agents.map((v) => [v.mainName, v])).values()];
        lowestPayment.sort(function (a, b) { return a.paymentAmount - b.paymentAmount; });
        tr_agents.map((id) => {
          if (lowestPayment[0]['mainName'] === id.mainName && id.onVacation === false) {
            lowestOrders.push(id);
          }
        });
        lowestOrders.sort(function (a, b) { return a.orderAmount - b.orderAmount; });
        const newAgentFee = {
          _id: lowestOrders[0]['_id'],
          mainName: lowestOrders[0]['mainName'],
          paymentAmount: lowestOrders[0]['paymentAmount'] + 0,
          orderAmount: lowestOrders[0]['orderAmount'] + 1
        };
        const newTransfer = {
          invoiceNo: values['invoiceNo'],
          manager: values['manager'].split('|')[0],
          clientName: values['clientName'],
          address: values['address'],
          agentPaid: false,
          agent: lowestOrders[0]['_id'],
          agentPaymentAmount: 0,
          completed: false,
          workNeeded: false,
          problem: false,
          customFees: null,
          clientPayment: null,
          currentlyWorking: false,
          workDone: false,
        };
        const combinedData = [newTransfer, newAgentFee]
        onAddTransfer({ dispatch, combinedData });
        // onAddTransfer({ dispatch, newTransfer })
        // onUpdateAgent({ dispatch, newAgentFee });
      }
      onAddPriorityOrder({ dispatch, newOrder: newPriorityOrder })
    }
    this.toggleNewOrderModal();
  }
  /**
   * Submit reason for locking an roder
   * @param {*} e 
   * @param {*} values 
   */
  handleLockOrderSubmit = (e, values) => {
    const { /* onUpdatePriorityOrder, */ profileData, dispatch } = this.props.props;
    const { priority_order } = this.state;
    const updatedPriorityOrder = {
      _id: priority_order._id,
      invoiceNo: priority_order.invoiceNo,
      bitrixID: priority_order.manager.split('|')[1],
      lockReason: values['lockReason'],
      lockedBy: profileData._id,
      lockedByName: profileData.fname +' '+profileData.sname,
      onHold: priority_order.onHold === true ? false : true,
      module: 'Bot Priority Notification',
      option: profileData._id !== priority_order.manager._id ? 'notifySManagerProrderLocked' : 'notifyWhManagerProrderLocked',
      // notifyLocked: true,
      // notifyManager: profileData._id !== priority_order.manager._id ? true : false,
      // notifyWhManager: profileData._id === priority_order.manager._id ? true : false,
      historyData: ''
    };
    const historyData = {
      order_id: priority_order['_id'],
      manager: profileData.fname + ' ' + profileData.sname,
      action: `<b>On Hold</b> value to ${priority_order.onHold ? '<b>on hold</b>' : '<b>not on hold</b>'} Reason: ${values['lockReason']}<br>`,
      updated: new Date().toLocaleString('en-GB')
    };
    updatedPriorityOrder['historyData'] = historyData
    onUpdatePriorityOrder({ dispatch, data: updatedPriorityOrder });
    this.toggleLockOrderModal();
  };
  /**
   * update warning state
   */
  updateWarningState = () => {
    const { priority_order, packingDate, selectedManager, isEdit } = this.state;
    if((!this.checkPriorityAvailability(packingDate, selectedManager) && isNull(this.myRef.current)) || (isEdit && this.checkPriorityAvailability(packingDate, selectedManager) && isNull(this.myRef.current))){
      this.setState({ warning: 'High priority is unchecked. This order will no longer be high priority' });
      if(priority_order) priority_order.importantOrder = false;
    } else { this.setState({ warning: null }); }
  }
  /**
   * Compare dates and times before allowing to select high priority order
   * @param {*} pckDate packing date
   * @returns Boolean
   */
  checkPriorityAvailability = (pckDate, selectedManager) => {
    const { priority_orders } = this.props.props;
    const { seoulTime2pm, priority_order, isEdit } = this.state;
    const packDate = new Date(pckDate.split('/').reverse().join('-')).setHours(0, 0, 0, 0)
    // get time in Seoul and current time
    const currentTime = moment(); // create a moment object for the current time
    // const seoulTime2pm = moment.tz('16:00', 'HH:mm', 'Asia/Seoul'); // create a moment object for 2pm in Seoul
    const isTimeBefore2PM = currentTime.isBefore(seoulTime2pm); // compare the two moments
    // get packing date and current date
    const packingDate = moment(packDate).startOf('day'); // create a moment object for the packing date
    const currentDate = moment().startOf('day'); // create a moment object for the current date
    const isPackingDateNotSameAsCurrentDate = !packingDate.isSame(currentDate); // compare if packing date is not same as current date
    const isPackingDateSameAsCurrentDate = packingDate.isSame(currentDate); // compare if packing date same as current date
    const isPackingDateAfterCurrentDate = packingDate.isAfter(currentDate); // compare if packing date after current date

    const noMatchingOrders  = isEdit ? priority_orders.filter(order => order._id !== priority_order._id && order.manager._id === selectedManager && order.packingDate === pckDate && order.importantOrder).length === 0
                                     : priority_orders.filter(order => order.manager._id === selectedManager && order.packingDate === pckDate && order.importantOrder).length === 0;

    return (isNaN(packingDate) && isTimeBefore2PM) || 
              (isPackingDateNotSameAsCurrentDate && isPackingDateAfterCurrentDate && noMatchingOrders) || 
              (isPackingDateSameAsCurrentDate && isTimeBefore2PM && noMatchingOrders) ;  
  }
  /**
   * Function to delete order from the table
   * @param {array} priority_order
   */
  handleDeletePriorityOrder = (priority_order) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteOrderAlert(priority_order)}
        onCancel={this.props.hideAlert}
        focusCancelBtn
      >
        The order with Invoice
        <span className='fw-bold'> #{priority_order.invoiceNo}</span> will be deleted from the
        system!
      </SweetAlert>
    );
    this.props.onStateChange('alert', getAlert());
  };
  /**
   * Function to delete an order from table and hide alert
   * @param {array} priority_order
   */
  deleteOrderAlert = (priority_order) => {
    const { dispatch } = this.props.props;
    onDeletePriorityOrder({ dispatch, order: priority_order });
    // onDeletePriorityOrder(priority_order);
    this.props.hideAlert();
  };
  render() {
    const { SearchBar } = Search;
    const { profileData, sl_managers, loading } = this.props.props;
    const { toolkitprops } = this.props;
    const {
      alertSc, 
      buttonTgl, 
      modalNewOrder, 
      modalLockOrder,
      isEdit, 
      priority_order,
      sl_manager_filter,
      startDate,
      endDate,
      paymentDate, 
      correctDatePm,
      packingDate,
      correctDatePack,
      sendDate,
      correctDateSend,
      selectedManager,
      transferAgentFields,
      error,
      warning
    } = this.state;
    return (
      <Row className='mt-1 mb-2'>
        <Col md='1' sm='12'>
          <div className='search-box d-inline-block '>
            <div className='position-relative'>
              <SearchBar {...toolkitprops.searchProps} />
              <i className='bx bx-search-alt search-icon' />
            </div>
          </div>
        </Col>
        <Col md='1' sm='12' className='ps-0 pe-0 mt-1'>
        {profileData.department.depName === 'Sales Department' && (
          <FormGroup className='d-flex ps-0 justify-content-between form-switch form-switch-lg form-group'>
            <Label for='myOrders'> My Orders </Label>
            <Input name='myOrders' onChange={(e) => this.filterMyOrders(e)} className='ms-4' id='myOrders' type='checkbox' value={false} />
          </FormGroup>
        )}
        </Col>
        <Col md='2' sm='12' className='d-flex ps-0 pe-0 mt-2'>
          <div className='search-box d-inline-block '>
            <a href='#' onClick={this.showServices}>Courier Services Schedule </a>
            <i className='fas fa-info-circle'></i>
          </div>
          {alertSc}
          <Notification compData={this.props.notifData} keyWord='prorder' module='Bot Priority Notification' />
        </Col>
        <Col md='4' sm='12'>
        {(profileData.permissions.includes('priorityArchiveBtnAccess') || profileData.accType === 'Admin') && (
          <AvForm className='d-flex' id='filter-date-form' onValidSubmit={this.handleFilterDataSubmit}>
            <FormGroup className='pe-1'>
              <AvField type='select' name='date_type' className='form-select prfilter fw-bold fs-5' defaultValue='pd' onChange={this.handleFilterChange}>
                <option value='pd' className='fw-bold fs-5'>Pay Date</option>
                <option value='sd' className='fw-bold fs-5'>Send Date</option>
              </AvField>
            </FormGroup>
            <FormGroup className='pe-1'>
              <InputMask
                mask='99/99/9999'
                value={startDate}
                name='startDate'
                onChange={this.onChangeValue}
                className='form-control input-mask prfilter fw-bold fs-5'
              />
            </FormGroup>
            <FormGroup className='pe-1'>
              <InputMask
                mask='99/99/9999'
                value={endDate}
                name='endDate'
                onChange={this.onChangeValue}
                className='form-control input-mask prfilter fw-bold fs-5'
              />
            </FormGroup>
            <FormGroup className='pe-1'>
              <AvField type='select' name='manager' className='form-select prfilter fw-bold fs-5' onChange={this.handleFilterChange} value={sl_manager_filter}>
                {profileData.department.depName !== 'Cosmetic Brand-Suppuru' && (<option value=''>All</option>)}
                {sl_managers
                  .filter(sl_manager => {
                    // If department is "Sales Department", show all managers
                    if (profileData.department.depName === 'Sales Department') return true;

                    // If department is "Cosmetic Brand-Suppuru", show only managers from that department
                    if (profileData.department.depName === 'Cosmetic Brand-Suppuru') {
                      return sl_manager.department?.depName === 'Cosmetic Brand-Suppuru';
                    }

                    // Default: exclude all others (or customize as needed)
                    return false;
                  })
                  .map((sl_manager, index) => (
                    <option key={index} className='fw-bold fs-5' value={sl_manager._id}>
                      {sl_manager.fname} {sl_manager.sname}
                    </option>
                  ))}
              </AvField>
            </FormGroup>
            <FormGroup className='me-1'>
              <button className='btn btn-success save-user' id='dblclick'>
                Filter
              </button>
            </FormGroup>
            <FormGroup className=''>
              <button type='reset' onClick={this.resetFilterData} className='btn btn-primary save-user'>
                Resets
              </button>
            </FormGroup>
          </AvForm>
        )}
        </Col>
        <Col md='2' sm='12'>
        {(profileData.permissions.includes('priorityCompletedBtnAccess') || profileData.accType === 'Admin') && (
          <Button
            color='primary'
            className='btn btn-warning save-user'
            onClick={this.handleHideCompletedOrders}
            id='create-order-btn'
          >
            <i className='mdi mdi-reload me-1' />
            Hide Completed Orders
          </Button>
        )}
        </Col>
        <Col md='1' sm='12' className='ps-0 pe-0 text-sm-end'>
        {(profileData.permissions.includes('priorityArchiveBtnAccess') || profileData.accType === 'Admin') && (
          <MyExportCSV {...toolkitprops.csvProps} />
        )}
        </Col>
        <Col md='1' sm='12' className='text-sm-end'>
        {(profileData.permissions.includes('priorityBtnNewOrderAccess')) && (
          <React.Fragment>
            <Button
              color='primary'
              className='btn btn-primary'
              onClick={this.handleNewOrderClick}
              id='create-order-btn'
            >
              <i className='mdi mdi-plus-circle-outline me-1' />
              Add Order
            </Button>
            <Modal
              size='xl'
              isOpen={modalNewOrder}
              className={this.props.className}
              toggle={this.toggleNewOrderModal}
            >
              <ModalHeader toggle={this.toggleNewOrderModal} tag='h4'>
                {!!isEdit ? 'Edit Order' : 'Add New Order'}
              </ModalHeader>
              <ModalBody>
                {error ? ( <Alert color='danger'> {' '}{error}{' '} </Alert> ) : null}
                {warning ? ( <Alert color='warning'> {' '}{warning}{' '} </Alert> ) : null}
                <AvForm onValidSubmit={this.handleValidOrderSubmit}>
                  <Row>
                    <Col md={8}>
                      {' '}
                      <Row>
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <Label>Payment Date</Label>
                            <InputMask
                              mask='99/99/9999'
                              value={paymentDate}
                              name='paymentDate'
                              ref={(el) => { this.autoFocusInput = el; }}
                              id='paymentDate'
                              onChange={this.onChangeDate}
                              className={
                                correctDatePm
                                  ? ' form-control input-mask'
                                  : 'form-control input-mask is-invalid'
                              }
                            />
                            {!correctDatePm && (
                              <div className='invalid-feedback'>
                                Invalid Date. Please use dd/mm/yyyy format
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <AvField
                              name='invoiceNo'
                              label='Inv №'
                              type='text'
                              errorMessage='Invalid Invoice №'
                              autoComplete='off'
                              validate={{
                                required: {
                                  value: true
                                }
                              }}
                              value={priority_order.invoiceNo || ''}
                            />
                          </FormGroup>
                          {this.checkPriorityAvailability(packingDate, selectedManager) && (
                          <FormGroup className='mb-3 new-client imp-order'>
                            <Label htmlFor='customCheckcolor1' className='form-check-label new-client-label'>
                              <i className='mdi mdi-priority-high mdi-24px' />
                              High Priority
                            </Label>
                            <AvField
                              name='importantOrder'
                              type='checkbox'
                              className='form-check-input new-client-input '
                              id='customCheckcolor1'
                              ref={this.myRef}
                              value={priority_order.importantOrder || false}
                              // disabled={!this.checkPriorityAvailability(packingDate, selectedManager)}
                            />
                          </FormGroup>
                          )}
                        </Col>
                        {/* <Col md={3}>
                          <FormGroup className='mb-3'>
                            <AvField
                              name='clientName'
                              label='Client Name'
                              type='text'
                              autoComplete='off'
                              value={priority_order.client_info ? priority_order.client_info.clientName : '' }
                            />
                          </FormGroup>
                        </Col> */}
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <AvField
                              name='clientName'
                              label='Client Name'
                              type='text'
                              autoComplete='off'
                              value={priority_order.client_info ? priority_order.client_info.clientName : '' }
                            />
                          </FormGroup>
                          <FormGroup className='mb-3 new-client to-wh'>
                            <Label htmlFor='customCheckcolor2' className='form-check-label new-client-label to-wh-label'>
                              To WH
                            </Label>
                            <AvField
                              name='toWH'
                              type='checkbox'
                              className='form-check-input new-client-input '
                              id='customCheckcolor2'
                              value={priority_order.toWH || ''}
                              // onClick={() => this.setState({ isNewClicked: !this.state.isNewClicked })}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <AvField
                              type='select'
                              name='manager'
                              id='manager'
                              className='form-select'
                              label='Manager'
                              errorMessage='Please select manager'
                              validate={{
                                required: {
                                  value: true
                                }
                              }}
                              onChange={this.onChangeSelectManager}
                              value={ priority_order.manager || profileData._id+'|'+profileData.bitrixID }
                            >
                              <option>Choose</option>
                              {sl_managers.map((manager) => {
                                return (
                                  <option
                                    key={manager._id}
                                    value={manager._id+'|'+manager.bitrixID}
                                  >
                                    {manager.fname} {manager.sname}
                                  </option>
                                );
                              })}
                            </AvField>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <Label>Packing Date</Label>
                            <InputMask
                              mask='99/99/9999'
                              value={packingDate || ''}
                              name='packingDate'
                              onChange={this.onChangeDate}
                              className={
                                correctDatePack
                                  ? ' form-control input-mask'
                                  : 'form-control input-mask is-invalid'
                              }
                            />
                            {!correctDatePack && (
                              <div className='invalid-feedback'>
                                Invalid Date. Please use dd/mm/yyyy format
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className='mb-3'>
                            <Label>Shipping Date</Label>
                            <InputMask
                              mask='99/99/9999'
                              value={sendDate || ''}
                              name='sendDate'
                              onChange={this.onChangeDate}
                              className={
                                correctDateSend
                                  ? ' form-control input-mask'
                                  : 'form-control input-mask is-invalid'
                              }
                            />
                            {!correctDateSend && (
                              <div className='invalid-feedback'>
                                Invalid Date. Please use dd/mm/yyyy format
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className='mb-3'>
                            <AvField
                              name='delService'
                              label='Delivery Service'
                              autoComplete='off'
                              list='urls'
                              value={priority_order.delService || ''}
                            />
                            <datalist id='urls'>
                              <optgroup label='Bank'>
                                <option>Pack</option>
                                <option>EMS</option>
                                <option>EMS MC</option>
                                <option>EMS MN</option>
                                <option>EMS Premium</option>
                                <option>FedEx</option>
                                <option>DHL</option>
                                <option>GLS</option>
                                <option>PGMC</option>
                                <option>Logistics</option>
                                <option>Korean Post</option>
                                <option>Quick</option>
                              </optgroup>
                            </datalist>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Row>
                            <Col md={10}>
                            {(priority_order.notificationSent === false || !priority_order.length) && (
                              <FormGroup className='mb-3 font-size-14'>
                                <AvField
                                  name='shouldSendNotification'
                                  type='checkbox'
                                  label='Notify when package is done'
                                  className='form-check-input'
                                  value={priority_order.shouldSendNotification || ''}
                                />
                              </FormGroup>
                            )}
                            </Col>
                            <Col md={2} className="ps-0 pe-0 text-sm-end">
                              <FormGroup className='mb-3'>
                                <AvField
                                  name='qr'
                                  type='checkbox'
                                  label='QR'
                                  className='form-check-input'
                                  value={priority_order.qr || ''}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={4}>
                              <FormGroup className='mb-3'>
                                <AvField
                                  name='threads'
                                  type='checkbox'
                                  label='Threads'
                                  className='form-check-input'
                                  value={priority_order.threads || ''}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4} className="ps-0 pe-0">
                              <FormGroup className='mb-3'>
                                <AvField
                                  name='docsReady'
                                  type='checkbox'
                                  label='Docs Ready'
                                  className='form-check-input'
                                  value={priority_order.docsReady || ''}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup className='mb-3'>
                                <AvField
                                  name='official'
                                  type='checkbox'
                                  label='Official'
                                  className='form-check-input'
                                  value={priority_order.official || ''}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup className='mb-3 '>
                            <AvField
                              name='managerCom'
                              label='Item Status'
                              type='textarea'
                              className='font-size-20'
                              rows='6'
                              autoComplete='off'
                              value={priority_order.managerCom || ''}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup className='mb-3 font-size-14'>
                            <AvField
                              name='transferAgentSent'
                              type='checkbox'
                              label='Send to Transfer Agent Table'
                              className='form-check-input'
                              onClick={this.toggleTransferAgent}
                              disabled={priority_order.transferAgentSent && true}
                              value={priority_order.transferAgentSent || ''}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {transferAgentFields && (
                        <Row>
                          <Col md={8}>
                            <FormGroup className='mb-3'>
                              <AvField
                                name='address'
                                label='Address'
                                autoComplete='off'
                                type='textarea'
                                value=''
                                rows='6'
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col>
                          <div className='text-end'>
                            {loading && <BtnLoader />}
                            <button
                              className='btn btn-success save-user'
                              id='submit-form'
                              disabled={loading && true}
                            >
                              {!!isEdit ? 'Edit Order' : 'Add Order'}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={4} className='text-left'>
                      {/* <hr className='vertical_line' /> */}
                      <h3 className='fw-bold'>Fedex/DHL</h3>
                      <hr className='horizontal_line' id='fedex' />
                      <p>Collect ~16:00</p>
                      <p>Official docs (CIPL) before 13:00</p>
                      <p>Other docs (CI, prod desc) before 15 00</p>

                      {/* <h3 className='fw-bold'>Docs </h3> */}
                      {/* <hr className='horizontal_line' id='kor_post'/> */}
                      {/* <h3 className='fw-bold'>DHL</h3>
                      <hr className='horizontal_line' id='dhl' />
                      <p>Collect ~16:00</p> */}

                      {/* <h3 className='fw-bold'>Docs </h3>
                      <hr className='hor_popup' id='kor_post' />
                      <p className='font-size-18'>Official docs before 13:00</p>
                      <p className='font-size-18'>Samples (ems prem) before 14:00</p> */}

                      <h3 className='fw-bold'>EMS</h3>
                      <hr className='horizontal_line' id='ems' />
                      <p>Collect ~15:00</p>
                      <p>Official docs (CIPL) before 13:00</p>
                      <p>Other docs-CI, declaration (ems premium) before 14 00</p>

                      <h3 className='fw-bold'>Korean post</h3>
                      <hr className='horizontal_line' id='q_serv' />
                      <p> ~next day before 12</p>
                      <h3 className='fw-bold'>Quick Service</h3>
                      <hr className='horizontal_line' id='q_serv' />
                      <p>On request</p>
                    </Col>
                  </Row>
                </AvForm>
              </ModalBody>
            </Modal>
          </React.Fragment>
          )}
        </Col>
        {/* Input lock reason modal */}
        <Modal
          size='lg'
          isOpen={modalLockOrder}
          className={this.props.className}
          toggle={this.toggleLockOrderModal}
        >
          <ModalHeader toggle={this.toggleLockOrderModal} tag='h4'>
            Please state a reason
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={this.handleLockOrderSubmit}>
              <Row>
                <Col md={12}>
                  <FormGroup className='mb-3'>
                    <AvField
                      name='lockReason'
                      label='Reason to lock'
                      type='textarea'
                      className='font-size-20'
                      rows='6'
                      autoComplete='off'
                      value={ priority_order.lockReason || '' }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className='text-end'>
                    {loading && <BtnLoader />}
                    <button className='btn btn-success save-user' disabled={loading && true}>
                      Hold Order
                    </button>
                  </div>
                </Col>
              </Row>
            </AvForm>
          </ModalBody>
        </Modal>
      </Row>
    )
  }
}

export default FilterPrComp
